import { PropType, defineComponent, onUnmounted, reactive, computed } from 'vue'
import styles from './styles.module.scss'
import { Store } from 'pinia'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import SearchBar from '../searchBar'
import ActionBar from '../actionBar'
import { MapViewMode } from '../../../contract/map'

export default defineComponent({
  name: 'handle-box',
  emits: ['handleFilter', 'hideFilter', 'goBackHome'],
  components: {},
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    xinfaView: {
      // 信发设备使用此组件,需要隐藏handleBox组件
      type: Boolean,
      default: false,
    },
  },
  setup: (props) => {
    // 获取组件配置
    // const componentStore = useComponentStore()
    const componentStore = computed(() => props.componentStore)
    // const mapContextRef = computed(() => props.mapContextRef)
    // const mapInstance = computed(() => props.mapInstance)
    // const BMapGL = computed(() => props.BMapGL)

    const state = reactive({
      input: false,
    })

    onUnmounted(() => {
      // componentStore.bus.off('handleClearSearchInput')
    })

    const handleBoxVisible = computed(() => {
      return (
        !props.xinfaView &&
        props.componentStore.showHandleBox &&
        !props.componentStore.showSummary &&
        props.componentStore.viewMode == MapViewMode.Init
      )
    })

    return () => {
      return (
        <div
          style={{
            visibility: handleBoxVisible.value ? 'visible' : 'hidden',
          }}
          class={[styles.handleBox, state.input ? styles.inputMode : '']}
        >
          <SearchBar componentStore={componentStore.value}></SearchBar>
          <ActionBar componentStore={componentStore.value}></ActionBar>
        </div>
      )
    }
  },
})
